import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-file-share",
  "use": "icon-file-share-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-file-share\"><defs><style type=\"text/css\"></style></defs><path d=\"M896 810.666667a128 128 0 0 1-256 0 89.173333 89.173333 0 0 1 0-10.666667 21.76 21.76 0 0 0-10.24-20.48l-279.04-162.986667a21.333333 21.333333 0 0 0-23.04 0A125.44 125.44 0 0 1 256 640a128 128 0 0 1 0-256 125.44 125.44 0 0 1 71.68 22.613333 21.333333 21.333333 0 0 0 23.04 0l279.466667-162.986666a21.76 21.76 0 0 0 9.813333-19.626667A89.173333 89.173333 0 0 1 640 213.333333a128 128 0 1 1 45.653333 97.28l-291.84 170.666667a21.76 21.76 0 0 0-10.24 20.48 133.546667 133.546667 0 0 1 0 21.333333 21.76 21.76 0 0 0 10.24 20.48l279.466667 162.986667a21.333333 21.333333 0 0 0 23.04 0A125.44 125.44 0 0 1 768 682.666667a128 128 0 0 1 128 128z\" p-id=\"38823\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/file-share.svg
// module id = 1djm
// module chunks = 22